import { render, staticRenderFns } from "./Debitoren.vue?vue&type=template&id=05a2bf0e&"
import script from "./Debitoren.vue?vue&type=script&lang=js&"
export * from "./Debitoren.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports